module.exports = __webpack_public_path__ + "static/media/card.ae48658c.svg";